<template>
  <footer class="preferences-footer">
    <slot />
  </footer>
</template>

<style lang="scss" scoped>
.preferences-footer {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-start;
  width: 100%;
  margin-top: 32px;
}
</style>
